import React, { useState } from 'react';

import { useSnrwbCore } from '../../../../common/hooks/useSnrwbCore';
import { ReportInspectedOrganizations } from '../../../../common/types/ReportTypes';
import { ReportByOrganizationType } from '../../../components/ReportByOrganizationType/ReportByOrganizationType';
import { Filter, FilterReportData } from '../../../components/Reports/Filter';
import abbreviationLegend from '../../../../common/abbreviationLegend';

export const ReportInspectedOrganizationView: React.FC = () => {
  const snrwbApi = useSnrwbCore();
  const [filterApplied, setFilterApplied] = useState(false);
  const [usedFilter, setUsedFilter] = useState<FilterReportData | undefined>(
    {},
  );
  const [data, setData] = useState<ReportInspectedOrganizations>({
    details: {},
    sum: {},
  });

  const onSearch = (filter?: FilterReportData) => {
    setFilterApplied(true);
    setUsedFilter(filter);
    snrwbApi.reports
      .reportInspectedOrganizations(false, filter)
      .then(dataReports => {
        setData(dataReports);
      });
  };

  return (
    <>
      <Filter onSearch={onSearch} reportName="Kontrole u podmiotów" />
      <ReportByOrganizationType
        data={data}
        reportName1="kontrole ogółem (suma poszczególnych)"
        reportName2="liczba kontroli u producentów"
        reportName3="liczba kontroli u importerów"
        reportName4="liczba kontroli u sprzedawców"
        reportName5="liczba kontroli u upoważnionych przedstawicieli producentów"
        filterApplied={filterApplied}
        usedFilter={usedFilter}
        reportName="Kontrole u podmiotów"
        legend={abbreviationLegend('inspectedProducts')}
      />
    </>
  );
};
